import React from "react";
import classnames from "classnames";
import "./Divider.scss";
import style from "../../scss/export.module.scss";

interface TDivider extends React.HTMLAttributes<HTMLHRElement> {
    color?: string;
    onDarkBackground?: boolean;
}

export const Divider = ({ color, onDarkBackground, ...props }: TDivider) => {
    const dividerClassName = classnames("c-divider", props.className);
    const dividerStyle = {
        ...props.style,
        borderColor: onDarkBackground ? style.whiteColor : color,
    };

    return <hr {...props} className={dividerClassName} style={dividerStyle} />;
};
